import * as React from 'react';

import { translate } from '~l10n/client';
import { throttle } from 'underscore';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export enum DeleteMessageType {
  DeleteQuestion = 'DELETE_QUESTION',
  DeleteStandard = 'DELETE_STANDARD',
}

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onDelete: () => void;
  deleteMessageType: string;
  isModalDisabled: boolean;
}

export function ConfirmDeleteDialog({
  open,
  onClose,
  onDelete,
  deleteMessageType,
  isModalDisabled,
}: Props) {
  const throttledHandleDelete = throttle(onDelete, 1000);
  const bodyText = (deleteMessageType: string) => {
    switch (deleteMessageType) {
      case DeleteMessageType.DeleteQuestion:
        return translate('Are you sure you want to delete this question?');
      case DeleteMessageType.DeleteStandard:
        return translate('Are you sure you want to remove this standard?');
    }
  };

  return (
    <DialogConfirmation
      id="confirm-delete"
      open={open}
      title={translate('Please Confirm')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton
          key="yes"
          appearance="primary"
          onClick={throttledHandleDelete}
          isDisabled={isModalDisabled}
        >
          {translate('Yes')}
        </UIButton>,
        <UIButton key="no" onClick={onClose} isDisabled={isModalDisabled}>
          {translate('No')}
        </UIButton>,
      ]}
    >
      {bodyText(deleteMessageType)}
    </DialogConfirmation>
  );
}
